import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { styled } from 'styled-components';
import { SpaceBetween, Typography, tk } from '@sunwebgroup/ui-components';
import type { TokenFunction } from '@sunwebgroup/ui-components';
import { Children, isValidElement } from 'react';

interface ListProps {
  direction?: 'x' | 'y';
  spacing?: string | TokenFunction;
}

export const FooterList = styled(SpaceBetween).attrs<ListProps>(
  ({ children, direction = 'y', spacing = tk('spacing_xs') }) => ({
    children: wrapItemsWithList(children),
    direction,
    spacing,
    forwardedAs: 'ul',
  })
)`
  color: inherit;
  list-style: none;
  margin: 0;
  padding: 0;
`;

interface ItemProps extends ComponentPropsWithoutRef<'li'> {
  href?: string;
}

function Item({ children, href, ...attrs }: ItemProps) {
  return <li {...attrs}>{href && <ItemLink href={href}>{children}</ItemLink>}</li>;
}

export const FooterListItem = styled(Item)`
  position: relative;
`;

const ItemLink = styled.a`
  text-decoration: none;
  ${Typography.modVariant('body-md')}
`;

function wrapItemsWithList(children: ReactNode | ReactNode[]) {
  return Children.map(children, (child) => {
    return isValidElement<typeof FooterListItem>(child) ? child : <FooterListItem>{child}</FooterListItem>;
  });
}
